import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import i18n from "./Language";
import reportWebVitals from './reportWebVitals';
import { MyProvider } from './Context/MyProvider';
import { BrowserRouter } from 'react-router-dom';

import AgoraRTC, { AgoraRTCProvider } from "agora-rtc-react";

const client = AgoraRTC.createClient({ mode: "rtc", codec: "vp8" });

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MyProvider>
        <AgoraRTCProvider client={client}>
          <App />
        </AgoraRTCProvider>
      </MyProvider>
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
